import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextInput from '../textInput/textInput';
import TextLabel from '../textLabel/textLabel';
import { CollapseArrow as CollapseArrowCE } from '@wix/wix-ui-icons-common/classic-editor/system';
import { CollapseArrow as CollapseArrowRE } from '@wix/wix-ui-icons-common/responsive-editor/system';
import { WixBaseUiEnvironmentContext } from '../../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
var TreeListItem = function TreeListItem(props) {
  var alwaysShowSuffix = props.alwaysShowSuffix,
    collapseState = props.collapseState,
    dataHook = props.dataHook,
    depth = props.depth,
    getClassName = props.getClassName,
    highlight = props.highlight,
    icon = props.icon,
    label = props.label,
    initialLabel = props.initialLabel,
    labelSuffix = props.labelSuffix,
    onClick = props.onClick,
    onDoubleClick = props.onDoubleClick,
    selected = props.selected,
    shouldTranslate = props.shouldTranslate,
    suffix = props.suffix,
    disabled = props.disabled,
    size = props.size,
    _props$isFocused = props.isFocused,
    isFocused = _props$isFocused === void 0 ? false : _props$isFocused,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    indication = props.indication,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave;
  var refElm = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isEditMode = _React$useState2[0],
    setIsEditMode = _React$useState2[1];
  var _React$useState3 = React.useState(initialLabel),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    labelText = _React$useState4[0],
    setLabelText = _React$useState4[1];
  React.useEffect(function () {
    if (isEditMode && labelText !== label) {
      onChange({
        label: labelText
      });
    }
  }, [labelText, isEditMode]);
  var suffixKeyDownHandler = function suffixKeyDownHandler(event) {
    if (event.key === 'Enter') {
      setIsEditMode(false);
    }
    if (event.key === 'Escape') {
      setIsEditMode(false);
    }
    if (event.keyCode === 32) {
      // 32 = Space key code
      setIsEditMode(true);
    }
  };
  var textWrapperKeyDownHandler = function textWrapperKeyDownHandler(event) {
    if (event.target.tagName === 'DIV' && (event.keyCode === 32 || event.key === 'Enter')) {
      // 32 = Space key code
      setIsEditMode(!isEditMode);
    }
  };
  var onKeyDownHandler = function onKeyDownHandler(event) {
    if (event.key === 'Escape') {
      setIsEditMode(false);
      setLabelText(label);
      onChange({
        label: label
      });
    }
  };
  var onClickHandler = function onClickHandler(e) {
    if (disabled) {
      return;
    }
    onClick(e);
  };
  var treeListItemTextOnDoubleClickHandler = function treeListItemTextOnDoubleClickHandler(e) {
    if (disabled || !isFocused) {
      return;
    }
    setIsEditMode(true);
  };
  var indicationArray = indication && (Array.isArray(indication) ? indication : [indication]);
  var labelNode = typeof label === 'string' ? /*#__PURE__*/React.createElement(TextLabel, {
    disabled: disabled,
    dataHook: "label",
    value: label || labelText,
    type: "T20",
    shouldTranslate: shouldTranslate,
    ref: refElm
  }) : label;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: getClassName(classNames('tree-list-item', {
      selected: selected,
      highlight: highlight,
      disabled: disabled
    }, size)),
    onClick: onClickHandler,
    onDoubleClick: onDoubleClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React.createElement("div", {
    className: "depth-margin",
    style: {
      '--baseui-tree-list-item-depth': depth
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-arrow-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-arrow ".concat(collapseState)
  }, /*#__PURE__*/React.createElement(WixBaseUiEnvironmentContext.Consumer, null, function (value) {
    return value && value.theme === 'responsive' ? /*#__PURE__*/React.createElement(CollapseArrowRE, null) : /*#__PURE__*/React.createElement(CollapseArrowCE, null);
  }))), icon && /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-icon"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-text-wrapper",
    tabIndex: isFocused && !disabled ? 0 : -1,
    onKeyDown: textWrapperKeyDownHandler
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": "tree-list-item-label",
    className: "tree-list-item-text",
    onDoubleClick: treeListItemTextOnDoubleClickHandler
  }, isEditMode ? null : labelNode, isFocused && isEditMode && !disabled && /*#__PURE__*/React.createElement(TextInput, {
    "data-hook": "tree-list-item-text-input",
    revertValueOnCancel: true,
    focus: true,
    inputHeight: "small",
    value: label || labelText,
    blurOnEnterKey: true,
    onChange: function onChange(val) {
      return setLabelText(val);
    },
    blurOnEscKey: false,
    onBlur: function onBlur() {
      return setIsEditMode(false);
    },
    onKeyDown: onKeyDownHandler
  })), labelSuffix && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: "label-suffix",
    className: "label-suffix",
    value: labelSuffix,
    type: "T20",
    enableEllipsis: false,
    shouldTranslate: shouldTranslate
  }))), indicationArray && /*#__PURE__*/React.createElement(React.Fragment, null, indicationArray.map(function (indicationItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "tree-list-item-indication"
    }, indicationItem.node);
  })), suffix && /*#__PURE__*/React.createElement("div", {
    className: classNames('tree-list-item-suffix', {
      'show-suffix': alwaysShowSuffix || isFocused
    }),
    onKeyDown: suffixKeyDownHandler,
    tabIndex: isFocused && !disabled ? 0 : -1
  }, suffix));
};
TreeListItem.displayName = displayNames.TREE_LIST_ITEM;
TreeListItem.propTypes = {
  /** alwaysShowSuffix */
  alwaysShowSuffix: PropTypes.bool,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** collapseState */
  collapseState: PropTypes.oneOf(['none', 'collapsed', 'expanded']),
  /** dataHook */
  dataHook: PropTypes.string,
  /** depth */
  depth: PropTypes.number,
  /** disabled */
  disabled: PropTypes.bool,
  /** highlight */
  highlight: PropTypes.bool,
  /** icon */
  icon: PropTypes.node,
  /** initialLabel- the uncontrolled value of the input */
  initialLabel: PropTypes.string,
  /** Determines whether the item is in focus */
  isFocused: PropTypes.bool,
  /** label- the controlled value of the input */
  label: PropTypes.node,
  /** labelSuffix */
  labelSuffix: PropTypes.string,
  /** Invoked on changes to list item */
  onChange: PropTypes.func,
  /** onClick */
  onClick: PropTypes.func.isRequired,
  /** onDoubleClick */
  onDoubleClick: PropTypes.func,
  /** selected */
  selected: PropTypes.bool,
  /** size */
  size: PropTypes.oneOf(['small', 'medium']),
  /** suffix */
  suffix: PropTypes.node,
  /** indication */
  indication: PropTypes.oneOfType([PropTypes.shape({
    node: PropTypes.node
  }), PropTypes.arrayOf(PropTypes.shape({
    node: PropTypes.node
  }))]),
  /** onMouseEnter */
  onMouseEnter: PropTypes.func,
  /** onMouseLeave */
  onMouseLeave: PropTypes.func
};
TreeListItem.defaultProps = {
  alwaysShowSuffix: false,
  collapseState: 'none',
  depth: 0,
  highlight: false,
  onDoubleClick: _.noop,
  selected: false,
  size: 'medium',
  disabled: false
};
export default compose(TreeListItem);